module.exports = __webpack_public_path__ + "4732aaaa041087accda5d49ce3233f20.pdf";